import { Box, styled } from '@mui/joy';

export const VBox = styled(Box, {
  slot: 'root',
  name: 'VBox'
})(() => ({ display: 'flex', flexDirection: 'column', alignItems: 'stretch', gap: 1 }))
